import React from 'react';

import * as eventsApi from '../../../api/eventsApi';
import tagular from '../../../util/tagular';

import './resultIndex.scss';

class ResultIndex extends React.Component {
    constructor(props) {
        super(props);

        this.toggleDisplay = this.toggleDisplay.bind(this);
        this.handleResultClick = this.handleResultClick.bind(this);
    }

    getPollOption() {
        const { pollOptionId, options } = this.props;

        let pollOption = {};

        if (options) {
            if (pollOptionId) {
                for (let option of options) {
                    if (option.id === pollOptionId) {
                        pollOption = option;
                        break;
                    }
                }
            } else {
                pollOption = options[0];
            }
        }

        return pollOption;
    }

    getResults() {
        const { pollOptionId, pollResults } = this.props;
        
        let results = [];

        if (pollResults && Object.keys(pollResults).length) {
            if (pollOptionId) {
                results = pollResults[pollOptionId] || [];
            } else {
                results = pollResults[Object.keys(pollResults)[0]];
            }
        }

        return results;
    }

    toggleDisplay() {
        return this.props.showResults ? 'show' : 'hide';
    }

    handleResultClick(e, result, position, pollOption) {
        const {
            pollInfo,
            inlineParentMetadata,
        } = this.props;

        eventsApi.articleSelected(pollOption.text, pollInfo.question, pollInfo, {
            position,
            destinationUrl: result.url,
            inlineParentMetadata
        });

        tagular.sendElementClickedEvent(e, { 
            position: 'Article Body', 
            location: 'CARDS', 
            name: 'Inline Poll', 
            action: 'INTERNALLINK',
            text: `${pollOption.text}_${result.url}`,
            htmlId: `${position}`,
            outboundUrl: result.url
        });
    }

    render() {
        const pollResults = this.getResults();
        const pollOption = this.getPollOption();

        const resultItems = pollResults.map((result, idx) => (
            <div className= 'result-item-container' id={result.id} key={result.id}>
                <div className='img-container'>
                    <img className='result-img' src={result.imageUrl} alt='' />
                </div>

                <div className='result-title-container'>
                    <a href={result.url} 
                        target='_blank' 
                        className='result-title link'
                        onClick={(e) => this.handleResultClick(e, result, idx, pollOption)}>

                        {result.title}
                    </a>
                </div>
            </div>
        ))

        return (
            <>
                {
                    pollResults.length ?
                        <div id={this.toggleDisplay()} className={`poll-results-container ${this.props.pollInfo.site}`}>
                            <h2 className='results-title'>{pollOption.resultTitle}</h2>
                            <div className='results-description'>{pollOption.resultDescription}</div>

                            <div className='result-items-container'>
                                {resultItems}
                            </div>
                        </div>
                        : null
                }
            </>
        )
    }
}

export default ResultIndex;